<template>
  <div class="chatgpt">
    <div>
      <span style="font-weight:blod;font-size: 16px;">ChatGPT API_KEY</span>
    </div>
    <el-button style="margin-top:20px;" type="primary" size="small" @click="addKey">新增</el-button>
    <div style="margin:20px;">
      <el-table :data="tableData" style="width: 100%" :header-cell-style="{ background: '#f5f7fa' }">
        <el-table-column prop="key" label="API_KEY" width="450">
        </el-table-column>
        <el-table-column prop="usageCount" label="使用次数">
        </el-table-column>
        <el-table-column prop="created_time" label="创建时间">
        </el-table-column>
        <el-table-column prop="update_time" label="更新时间">
        </el-table-column>
        <el-table-column label="操作">
          <template slot-scope="scope">
            <!-- <el-button type="text" @click="edit(scope.row)">编辑</el-button> -->
            <el-button type="text" @click="del(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <!-- <el-input style="width:600px;" v-model="api_key" placeholder="请输入API_KEY"></el-input> -->

      <!-- <span style="margin-left:20px;">更新时间: {{ update_time }}</span> -->

      <!-- <br /> -->

      <!-- <el-button style="margin-top:20px;" type="primary" @click="adminCreateChatGptKey" size="small">设置</el-button> -->
      <el-dialog title="设置API_KEY" :visible.sync="dialogVisible" width="30%">
        <el-input v-model="api_key" placeholder="请输入API_KEY" clearable></el-input>
        <span slot="footer" class="dialog-footer">
          <el-button @click="dialogVisible = false">取 消</el-button>
          <el-button type="primary" @click="adminCreateChatGptKey">确 定</el-button>
        </span>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import {
  adminGetGhatGptKey,
  adminCreateChatGptKey,
  adminDeleteChatGptKey
  // getEducationalInstitutionList,
  // adminAddOrUpdateSchoolTag,
  // adminGetSchoolTagList,
  // adminDeleteSchoolTag,
} from "@/api/admin.js";
export default {
  name: "chatgpt",
  data() {
    return {
      tableData: [],

      educational_institution_list: [],
      total: 0,
      page_no: 1,
      tagId: "",
      form: {
        name: "",
        sort_num: 1,
        remark: "",
        color: "",
      },
      dialogVisible: false,
      rules: {
        name: [
          {
            required: true,
            message: "请输入标题",
            trigger: "change",
          },
          {
            required: true,
            message: "请输入标题",
            trigger: "blur",
          },
        ],
      },
      schoolTagList: [],
      chatGptKeyList: [],
      api_key: "",
      update_time: "",
    };
  },
  mounted() {
    this.adminGetGhatGptKey();
  },
  methods: {
    //新增
    addKey(val) {
      this.api_key = ''
      console.log(val, 123456);
      this.dialogVisible = true

    },
    //编辑
    // edit(row) {
    //   this.api_key = row.key
    //   console.log(row, 12346);
    //   this.dialogVisible = true
    // },
    //删除key
    del(row) {
      console.log(row);
      this.$confirm('是否删除当前key?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        adminDeleteChatGptKey({
          id: row.id
        }).then((res) => {
          this.$message({
            type: 'success',
            message: '删除成功!'
          });
          console.log(res, 12346);
          this.adminGetGhatGptKey();
        })
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });
    },
    //查询API_KEY
    adminGetGhatGptKey() {
      adminGetGhatGptKey().then((res) => {
        console.log("ChatGPT_API_KEY");
        console.log(res);
        this.tableData = res.chatGptKeyList
      });
    },

    adminCreateChatGptKey() {
      if (!this.api_key) {
        this.$message.warning("API_KEY不能为空");
        return;
      }

      adminCreateChatGptKey({
        key: this.api_key,
      }).then((res) => {
        console.log(res);
        console.log("更新成功");
        this.dialogVisible = false
        this.$message.success("设置成功！");
        this.adminGetGhatGptKey();
      });
    },


  },
};
</script>

<style scoped lang="scss">
.chatgpt {
  height: 100%;
  background-color: #fff;
  padding: 15px;
  margin: 15px;
  border-radius: 5px;

  .form-style {
    margin-left: 15px;
  }

  .table-style {
    margin-top: 20px;
  }
}
</style>
